import { render, staticRenderFns } from "./iconography.vue?vue&type=template&id=2c304418&"
import script from "./iconography.vue?vue&type=script&lang=js&"
export * from "./iconography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports